import { AntragMetaData } from '@eBeihilfe/einreichung-shared/model';
import { Application } from '../models';
import { ApplicationsUpdateState } from '../reducers/applications-update.reducer';
import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { applicationsUpdateActions } from '../actions';
import {
  selectApplicationsUpdateData,
  selectApplicationsUpdateError,
  selectApplicationsUpdateLoading,
} from '../selectors';

@Injectable()
export class ApplicationsUpdateFacade {
  private readonly store: Store<ApplicationsUpdateState> = inject(Store);

  public update(application: Application, metadata: AntragMetaData): void {
    this.store.dispatch(
      applicationsUpdateActions.update({
        application,
        metadata,
      }),
    );
  }

  public selectData(): Signal<Application> {
    return this.store.selectSignal(selectApplicationsUpdateData);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsUpdateLoading);
  }

  public selectError(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsUpdateError);
  }

  public clearStore(): void {
    this.store.dispatch(applicationsUpdateActions.clearStore());
  }
}
